import {
  Button,
  CheckCircleIcon,
  DocumentTextIcon,
  Flex,
  GlobeAltIcon,
  Image,
  Link,
  Text,
} from 'components'
import { DraftSession } from 'types'
import { useLocalStorage } from 'usehooks-ts'
import ticket from '../assets/ticket.gif'
import { getResultLayoutAssets, useEvent } from '../utils'

interface Props {
  userSession: DraftSession
}

export default function RegistrationCompleteTile({ userSession }: Props) {
  const event = useEvent()
  const { id, showTicket } = event || {}
  const [redeemed, setRedeemed] = useLocalStorage<boolean>(`redeemed-${id}`, !showTicket)
  const resultLayoutAssets = getResultLayoutAssets({
    additionalFields: event?.template.traitMap,
    layoutMap: event?.template.layoutMap,
    media: event?.media,
    routing: event?.template.routing,
    tools: event?.tools,
    userSession,
  })

  return redeemed ? (
    <Flex
      align="center"
      bg="white"
      borderRadius="md"
      direction="column"
      gap={4}
      m={4}
      mt={-8}
      p={4}
      textAlign="center"
      zIndex={2}
    >
      <CheckCircleIcon color="green" size="lg" type="outline" />
      <Text textStyle="h5">All Done!</Text>
      <Text textStyle="bodySmall">
        Thank you for participating, keep an eye out for updates from us if you opted in for
        marketing communication.
      </Text>
      {resultLayoutAssets.length > 0 && (
        <Flex direction="column" gap={2}>
          {resultLayoutAssets.map(asset => (
            <Flex key={asset.id}>
              <Link href={asset.url} rel="noopener noreferrer" target="_blank" w="full">
                <Flex
                  align="center"
                  borderRadius="sm"
                  borderWidth={1}
                  gap={3}
                  p={3}
                  textAlign="left"
                  w="full"
                  color="black"
                >
                  {asset.type === 'tool' ? (
                    <GlobeAltIcon size="sm" type="outline" />
                  ) : (
                    <DocumentTextIcon size="sm" type="outline" />
                  )}
                  <Text textStyle="bodySmall">{asset.title}</Text>
                </Flex>
              </Link>
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  ) : (
    <Flex direction="column" gap={3} m={4} mt={-8}>
      <Flex
        align="center"
        bg="white"
        borderRadius="md"
        direction="column"
        gap={4}
        p={4}
        textAlign="center"
        zIndex={2}
      >
        <Text textStyle="h5">All Done!</Text>
        <Image alt="Ticket to claim swag" draggable={false} src={ticket} width="60%" />
        <Text textStyle="bodySmall">
          Please show this to the nearest representative to claim your swag.
        </Text>
      </Flex>
      <Button bg="rgba(255, 255, 255, 0.54)" onClick={() => setRedeemed(true)} variant="outline">
        Redeemed
      </Button>
    </Flex>
  )
}
